import { fetchWithAuth } from '../utils/fetchWithAuth';


export async function getStatusPayments() {
    try{
        const response = await fetchWithAuth('/admin/settings/payments', {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
}

export async function updateStatusPayments(enabled) {
    try {
        const response = await fetchWithAuth('/admin/settings/payments', {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ enabled }),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
}